import { Box, Grid } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { LoadingButton } from "@mui/lab";
import FormikControl from "../../common/FormikControl";
import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { rePrintForQR } from "../../../slices/QRCode";

const RePrintForm = ({ qrCodeId, bagCount, handleCloseModal, handlePrint }) => {
  const dispatch = useDispatch();
  const [formOptions, setFormOptions] = useState([]);
  const initialValues = {
    print_type: "1",
    bags: "",
    reason: ""
  }
  const validationSchema = (bagCount) => Yup.object().shape({
    bags: Yup.string()
      .nullable()
      .matches(/^\d{1,24}$/, "Must be a valid number with up to 24 digits")
      .required("This is a required field")
      .when("print_type", {
      is: (val) => val === "1",
        then: (schema) =>
          schema.test(
            "maxBagNumber",
            `Bag Number must not exceed 5`,
            (value) => {
              if (!value) return true;
              return bagCount + Number(value) <= 5;
            }
          ),
      })
      .when("print_type", {
        is: (val) => val === "2",
          then: (schema) =>
            schema.test(
              "maxBagNumberReprint",
              `Bag number must not exceed current bag count : ${bagCount}`,
              (value) => {
                if (!value) return true;
                return Number(value) <= bagCount;
              }
            ),
        }),
  
    reason: Yup.string()
      .nullable()
      .required("This is a required field")
      .max(240, "Must not exceed 240 characters"),
  });
  

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      let payload = {};
      if (values.print_type == "1") {
        payload.number_of_bags = values.bags;
        payload.reprint = "NEW";
        payload.reason = values.reason;
        payload.id = qrCodeId;
      } else {
        payload.bag_number = values.bags;
        payload.reason = values.reason;
        payload.id = qrCodeId;
      }

      const rePrintQR = await dispatch(rePrintForQR(payload)).unwrap();
      if (rePrintQR.success) {
        if (values.print_type == "1") {
          handlePrint({ bags: values?.bags });
        } else {
          handlePrint({ bag_no: values?.bags });
        }
        handleCloseModal();
      }
    } finally {
      formik.handleReset()
      setSubmitting(false);
    }
  };



  const formik = useFormik({
    initialValues,
    validationSchema: validationSchema(bagCount),
    onSubmit: handleSubmit
  })


  useEffect(() => {
    setFormOptions([
      {
        type: "radio",
        name: "print_type",
        label: "Print Type",
        options: [
          { value: "1", label: "Print New" },
          { value: "2", label: "Re-Print" },
        ],
      },
      {
        type: "number",
        name: "bags",
        label: formik.values.print_type === "2" ? "Bag Number" : "Number of Bags",
        placeholder: "Enter number",
        required: true,
      },
      {
        type: "textarea",
        name: "reason",
        label: "Reason",
        placeholder: "Enter reason here",
        required: true,
      },
    ]);
    
    formik.setValues((prevValues) => ({
      ...prevValues,
      bags: "",
      reason: "",
    }));
  
    formik.setErrors({});
    formik.setTouched({});
  
  }, [formik.values.print_type]);


  return (
    <Box>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={2} className="mb-3">
          {formOptions.map((props, key) => (
            <Grid key={key} item xs={12}>
              <FormikControl formik={formik} {...props} />
            </Grid>
          ))}
        </Grid>
        <Grid container spacing={2} className="pt-2 pb-2">
          <Grid item xs={12}>
            <LoadingButton fullWidth type="submit" variant="contained" loading={formik.isSubmitting} disabled={formik.isSubmitting} >Submit</LoadingButton>
          </Grid>
        </Grid>
      </form>
    </Box >
  );
}

export default RePrintForm;